export default "__VITE_ASSET__B6Cn8mcv__"